import React, {Component} from 'react';
import {connectHits} from "react-instantsearch-dom";
// UI
import Grid from "@material-ui/core/Grid";
import DetailedCarCardBlue from "../../DetailedCarCardBlue";
import {appStyle} from '../../../theme/appStyle';
import {withStyles} from "@material-ui/core";
import TestDriveCard from "../../TestDriveCard";

class AlgoliaHitsBlue extends Component {
    render() {
        const { hits } = this.props;
        const testDrivePosition = 4;

        const itemsWithTestDrive = [];
        hits.forEach((hit, index) => {
                itemsWithTestDrive.push(
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4}
                              key={hit.rom_ref || `key-${index}-${hit.configuration_id}`}
                        >
                            <DetailedCarCardBlue data={hit}/>
                        </Grid>
                );

            // Insert test drive card after the specified position
            if (index === testDrivePosition) {
                itemsWithTestDrive.push(
                    <Grid item xs={12} sm={6} md={6} lg={4} xl={4} key="test-drive-card">
                        <TestDriveCard />
                    </Grid>
                );
            }
        });

        return itemsWithTestDrive;
    }
}

AlgoliaHitsBlue = withStyles(appStyle)(AlgoliaHitsBlue);
AlgoliaHitsBlue = connectHits(AlgoliaHitsBlue);
export default AlgoliaHitsBlue;
